import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

function FlexColumn ({ children, className, style, ...rest }) {
  return (
    <div {...rest} className={clsx(className, 'flex flex-col gap-sm')} style={style}>{children}</div>
  )
}

FlexColumn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

export default FlexColumn
